import { ResetPasswordEntity } from './../models/reset-password';
import { axiosService, AxiosService } from './axios.service';

// import { UserCredentials } from './../models/user-credentials';


/*
 *
 * Authentication Service
 *
 */

class AuthenticationService {

    constructor(private httpService: AxiosService) {}

    public login(user: any /* UserCredentials */) {
        return this.httpService.post('/auth/b2b/login', { email: user.email, password: user.password });
    }

    public resetPassword(password: ResetPasswordEntity) {
        return this.httpService.post('/users/me/resetPassword', password);
    }

    public logout() {
        return this.httpService.$http.get('/logout');
    }

}

export default new AuthenticationService(axiosService);
